import React from 'react'
import {Link} from 'react-router-dom'
import {createFromIconfontCN} from '@ant-design/icons'

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1669226_dnh2z25bezt.js',
})

const Product = ({product}) => {
  const type = product.type
  const prod = type ? product.product[Object.keys(product.product)[0]] : product

  return (
    <Link to={`/product/${type}/${type === 'ean' ? prod.ean : `${prod.target_id}/${prod.external_id}`}`}>
      <div className='productItem'>
        <div className='mainImage'>
          <img src={prod?.main_image_url} alt={prod?.name ?? prod.uuid}/>
          <div className='circle'>
            <div className='innerCircle'>
              <div className='shopNow'>
                SHOP NOW
              </div>
            </div>
          </div>
        </div>
        <p className='titleText'>{prod?.name ?? prod.uuid}</p>
        <div className='priceLine'>
          {type === 'ean' && <div className='fromSign'>from:</div>}
          <div className='price'>£ 4.90</div>
        </div>
        <div className='storesLine'>
          <div className='locationImage'>
            <IconFont type='icon-place'/>
          </div>
          <div className='shopLine'>
            {type === 'ean' ? 'in multiple shops' : 'in one shop'}
          </div>
        </div>
      </div>
    </Link>
  )
}

export default Product
